import React, { useEffect } from "react";
import { useState } from "react";
import {
  KeyboardArrowDownRounded,
  KeyboardArrowUpRounded,
  Settings,
} from "@mui/icons-material";
import {
  Button,
  Card,
  Collapse,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { getWorkingArea } from "../../../../redux/reducer/workingArea/workingAreaReducer";
import { getBank } from "../../../../redux/reducer/bank/bankReducer";
import { getData } from "../../../../service/Service";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import {
  farmerActions,
  getFarmerById,
  postFarmer,
} from "../../../../redux/reducer/farmer/farmerReducer";
import { getPriceType } from "../../../../redux/reducer/priceType/priceTypeReducer";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    background: "#ddd",
    textAlign: "center",
    borderBottom: "1px solid #D1CDCD",
    padding: "1em",
  },
  tableCell: {
    background: "#ddd",
    borderBottom: "1px solid #D1CDCD",
    padding: "5px 0px",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));
export default function AdminFarmerTambah() {
  // Navigate
  const navigate = useNavigate();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const workingArea = useSelector((state) => state.workingArea.data);
  const bank = useSelector((state) => state.bank.data);
  const priceType = useSelector((state) => state.priceType.data);

  // Local State
  const [formData, setFormData] = useState({
    farmerCode: "",
    ktpNumber: "",
    fullName: "",
    phoneNumber: "",
    address: "",
    workingAreaId: "",
    bankId: "",
    accountNumber: "",
    accountName: "",
    priceTypeId: "",
  });
  const [certificates, setCertificates] = useState([]);
  const [fetch, setFetch] = useState(true);
  const [cardsSetting, setCardsSetting] = useState({
    informasiPribadi: true,
    dataSertifikat: false,
    dataBank: false,
  });

  // Column
  const certificatesColumn = ["Nama Sertifikat", "Tahun", "Deskripsi", "Aksi"];

  useEffect(() => {
    if (fetch) {
      handleAddCertificates();
      setFetch(false);
    }
  }, [fetch]);

  // Basic Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handling Certificates
  const handleCertificates = (index) => (e) => {
    const newItems = [...certificates];
    newItems[index][e.target.name] = e.target.value;
    setCertificates(newItems);
  };

  const handleAddCertificates = () => {
    setCertificates((prevItems) => [
      ...prevItems,
      {
        certificateName: "",
        certificateYear: "",
        certificateDescription: "",
      },
    ]);
  };

  const handleDeleteCertificates = (value) => {
    let deletedData = [];
    for (let i = 0; i < certificates.length; i++) {
      if (i !== value) {
        deletedData.push(certificates[i]);
      }
    }
    setCertificates(deletedData);
  };

  const handleGenerateCode = () => {
    getData("/master/farmer/generate-code", token, null)
      .then((res) => {
        setFormData({
          ...formData,
          farmerCode: res.data.data,
        });
        toast.success(res.data.message);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };

  const handleCollapse = (val) => {
    switch (val) {
      case 1:
        setCardsSetting({
          ...cardsSetting,
          informasiPribadi: !cardsSetting.informasiPribadi,
        });
        break;
      case 2:
        setCardsSetting({
          ...cardsSetting,
          dataSertifikat: !cardsSetting.dataSertifikat,
        });
        break;
      case 3:
        setCardsSetting({ ...cardsSetting, dataBank: !cardsSetting.dataBank });
        break;
      default:
        break;
    }
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (workingArea.totalDocs !== workingArea.docs.length && value === 1) {
        const getData = {
          params: {
            limit: workingArea.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getWorkingArea(getData));
      } else if (bank.totalDocs !== bank.docs.length && value === 2) {
        const getData = {
          params: {
            limit: bank.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getBank(getData));
      } else if (priceType.totalDocs !== priceType.docs.length && value === 3) {
        const getData = {
          params: {
            limit: priceType.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getPriceType(getData));
      }
    }
  };

  const handleSubmit = (value) => (event) => {
    event.preventDefault();
    switch (value) {
      case 1:
        setCardsSetting({
          informasiPribadi: false,
          dataSertifikat: true,
          dataBank: false,
        });
        break;
      case 2:
        setCardsSetting({
          informasiPribadi: false,
          dataSertifikat: false,
          dataBank: true,
        });
        break;
      default:
        break;
    }
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          data: {
            farmerCode: formData.farmerCode,
            ktpNumber: formData.ktpNumber,
            fullName: formData.fullName,
            address: formData.address,
            phoneNumber: formData.phoneNumber,
            certificate: certificates,
            workingAreaId: formData.workingAreaId,
            priceTypeId: formData.priceTypeId,
            bankAccount: {
              bankId: formData.bankId,
              accountNumber: formData.accountNumber,
              accountName: formData.accountName,
            },
          },
          token: token,
        };
        dispatch(postFarmer(data)).then((res) => {
          if (res.payload.status === 201) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getFarmerById(dataGetById)).then((result) => {
              dispatch(farmerActions.addFarmer(result.payload.data));
              toast.success(res.payload.message);
              navigate("/admin/petani");
            });
          }
        });
      } else {
        return;
      }
    });
  };
  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          TAMBAH PETANI
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"
          minWidth={"100%"}
        >
          <Grid items>
            <Typography fontSize={16} color={"#2D6B56"} variant="h6">
              INFORMASI PRIBADI
            </Typography>
          </Grid>
          <Grid
            items
            style={{
              display: "flex",
              alignItems: "center",
              borderRadius: "50px",
              background: "#386e5b",
              color: "white",
            }}
          >
            {!cardsSetting.informasiPribadi ? (
              <KeyboardArrowDownRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(1)}
              />
            ) : (
              <KeyboardArrowUpRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(1)}
              />
            )}
          </Grid>
        </Grid>
        <Divider className={styles.dividerStyle} />

        <Collapse style={{ width: "100%" }} in={cardsSetting.informasiPribadi}>
          <form
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
            onSubmit={handleSubmit(1)}
          >
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                margin: "10px 0px",
                flexDirection: "row",
                background: "none",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                KODE PETANI
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{ maxLength: 20, style: { background: "white" } }}
                required
                helperText={
                  formData.farmerCode.length > 0
                    ? /^[A-Za-z]{3}-\d{5}/.test(formData.farmerCode)
                      ? ""
                      : "*Format Kode Petani salah"
                    : ""
                }
                size="small"
                error={
                  formData.farmerCode.length > 0
                    ? /^[A-Za-z]{3}-\d{5}/.test(formData.farmerCode)
                      ? false
                      : true
                    : false
                }
                name="farmerCode"
                onChange={handleChange}
                value={formData.farmerCode}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  marginRight: "10px",
                }}
              />
              <Button
                size="small"
                variant="contained"
                onClick={() => handleGenerateCode()}
              >
                <Settings />
              </Button>
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
                background: "none",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                NO KTP
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                size="small"
                error={/^[0-9]*$/.test(formData.ktpNumber) ? false : true}
                helperText={
                  /^[0-9]*$/.test(formData.ktpNumber)
                    ? ""
                    : "*Formart No KTP salah"
                }
                inputProps={{ maxLength: 16, style: { background: "white" } }}
                name="ktpNumber"
                onChange={handleChange}
                value={formData.ktpNumber}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                marginBottom: "10px",
                width: "100%",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                NAMA LENGKAP
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{ maxLength: 50 }}
                required
                size="small"
                error={false}
                name="fullName"
                onChange={handleChange}
                value={formData.fullName}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                marginBottom: "10px",
                width: "100%",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                NO TELP
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{ maxLength: 20, style: { background: "white" } }}
                required
                type="tel"
                size="small"
                error={/^[0-9]*$/.test(formData.phoneNumber) ? false : true}
                helperText={
                  /^[0-9]*$/.test(formData.phoneNumber)
                    ? ""
                    : "*Formart No Telepon salah"
                }
                name="phoneNumber"
                onChange={handleChange}
                value={formData.phoneNumber}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                marginBottom: "10px",
                width: "100%",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                ALAMAT
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                size="small"
                inputProps={{ maxLength: 250 }}
                error={false}
                name="address"
                onChange={handleChange}
                value={formData.address}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              />
            </FormControl>

            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                AREA
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                select
                required
                size="small"
                error={false}
                name="workingAreaId"
                onChange={handleChange}
                value={formData.workingAreaId}
                fullWidth
                variant="outlined"
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      onScroll: loadMore(1),
                    },
                    style: {
                      height: "300px",
                    },
                  },
                }}
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              >
                {workingArea.docs.length > 0 ? (
                  workingArea.docs.map((data, index) => (
                    <MenuItem value={data._id} key={index}>
                      {data.areaName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">Data kosong</MenuItem>
                )}
              </TextField>
            </FormControl>

            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                TIPE HARGA
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                select
                required
                size="small"
                error={false}
                name="priceTypeId"
                onChange={handleChange}
                value={formData.priceTypeId}
                fullWidth
                variant="outlined"
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      onScroll: loadMore(3),
                    },
                    style: {
                      height: "300px",
                    },
                  },
                }}
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              >
                {priceType.docs.length > 0 ? (
                  priceType.docs.map((data, index) => (
                    <MenuItem value={data._id} key={index}>
                      {data.typeName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">Data kosong</MenuItem>
                )}
              </TextField>
            </FormControl>

            <div className={styles.footerButton}>
              <Button type="submit" variant="contained">
                NEXT
              </Button>
            </div>
          </form>
        </Collapse>
      </Card>
      <Card className={styles.headerClass}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"
          minWidth={"100%"}
        >
          <Grid items>
            <Typography fontSize={16} color={"#2D6B56"} variant="h6">
              DATA SERTIFIKAT
            </Typography>
          </Grid>
          <Grid
            items
            style={{
              display: "flex",
              alignItems: "center",
              borderRadius: "50px",
              background: "#386e5b",
              color: "white",
            }}
          >
            {!cardsSetting.dataSertifikat ? (
              <KeyboardArrowDownRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(2)}
              />
            ) : (
              <KeyboardArrowUpRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(2)}
              />
            )}
          </Grid>
        </Grid>
        <Divider className={styles.dividerStyle} />
        <Collapse style={{ width: "100%" }} in={cardsSetting.dataSertifikat}>
          <form style={{ width: "100%" }} onSubmit={handleSubmit(2)}>
            <Typography marginTop={1}>Data Sertifikat :</Typography>
            <table
              style={{
                width: "100%",
                marginBottom: "10px",
                borderCollapse: "collapse",
                borderRadius: "1em",
                overflow: "hidden",
              }}
            >
              <thead>
                {certificatesColumn.map((item, index) => {
                  return (
                    <td className={styles.tableHeader} key={index}>
                      {item}
                    </td>
                  );
                })}
              </thead>
              <tbody>
                {certificates.length > 0 &&
                  certificates.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              error={false}
                              name="certificateName"
                              inputProps={{ maxLength: 50 }}
                              id={index}
                              onChange={handleCertificates(index)}
                              value={item.certificateName}
                              variant="outlined"
                              fullWidth
                              style={{
                                maxWidth: "400px",
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              inputProps={{ maxLength: 25 }}
                              error={false}
                              name="certificateYear"
                              id={index}
                              onChange={handleCertificates(index)}
                              value={item.certificateYear}
                              variant="outlined"
                              fullWidth
                              style={{
                                maxWidth: "400px",
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              inputProps={{ maxLength: 25 }}
                              error={false}
                              name="certificateDescription"
                              id={index}
                              onChange={handleCertificates(index)}
                              value={item.certificateDescription}
                              variant="outlined"
                              fullWidth
                              style={{
                                maxWidth: "400px",
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>
                        <td className={styles.tableCell}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              margin: "auto",
                              width: "100px",
                            }}
                          >
                            <AddIcon
                              className={styles.actionButtonEdit}
                              onClick={() => handleAddCertificates()}
                            />
                            {certificates.length > 1 && index !== 0 ? (
                              <RemoveIcon
                                className={styles.actionButtonEdit}
                                onClick={() => handleDeleteCertificates(index)}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <div className={styles.footerButton}>
              <Button variant="contained" type="submit">
                NEXT
              </Button>
            </div>
          </form>
        </Collapse>
      </Card>
      <Card className={styles.headerClass}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"
          minWidth={"100%"}
        >
          <Grid items>
            <Typography fontSize={16} color={"#2D6B56"} variant="h6">
              DATA BANK
            </Typography>
          </Grid>
          <Grid
            items
            style={{
              display: "flex",
              alignItems: "center",
              borderRadius: "50px",
              background: "#386e5b",
              color: "white",
            }}
          >
            {!cardsSetting.dataBank ? (
              <KeyboardArrowDownRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(3)}
              />
            ) : (
              <KeyboardArrowUpRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(3)}
              />
            )}
          </Grid>
        </Grid>
        <Divider className={styles.dividerStyle} />
        <Collapse style={{ width: "100%" }} in={cardsSetting.dataBank}>
          <form
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
            onSubmit={handleSubmitAll}
          >
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                PILIH BANK
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                select
                size="small"
                error={false}
                name="bankId"
                onChange={handleChange}
                value={formData.bankId}
                fullWidth
                variant="outlined"
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      onScroll: loadMore(2),
                    },
                    style: {
                      height: "300px",
                    },
                  },
                }}
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              >
                {bank.docs.length > 0 ? (
                  bank.docs.map((data, index) => (
                    <MenuItem value={data._id} key={index}>
                      {data.bankName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">Data kosong</MenuItem>
                )}
              </TextField>
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                NO REKENING
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{ style: { background: "white" } }}
                required
                size="small"
                error={/^[0-9]*$/.test(formData.accountNumber) ? false : true}
                helperText={
                  /^[0-9]*$/.test(formData.accountNumber)
                    ? ""
                    : "*No Rekening tidak valid"
                }
                name="accountNumber"
                onChange={handleChange}
                value={formData.accountNumber}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                NAMA REKENING
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                size="small"
                inputProps={{ maxLength: 50 }}
                error={false}
                name="accountName"
                onChange={handleChange}
                value={formData.accountName}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <div className={styles.footerButton}>
              <Button variant="contained" type="submit">
                SUBMIT
              </Button>
              <Button
                variant="contained"
                color="error"
                style={{ marginLeft: "10px" }}
                onClick={() => navigate("/admin/petani")}
              >
                KEMBALI
              </Button>
            </div>
          </form>
        </Collapse>
      </Card>
    </Grid>
  );
}
